/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import { useState } from "react"
import { Button, Grid } from "@cd2/components"
import { LabelInfo } from "./LabelInfo"
import { IComponentProps } from "@cd2/tools"
import { useTheme } from "@cd2/theme/build/es6"

interface IProps {
  data: IComponentProps<typeof LabelInfo>[]
  moreData?: IComponentProps<typeof LabelInfo>[]
  inline?: boolean
  labelWidth?: number
  light?: boolean
  gap?: number
}

export function KeyValueList({ data, moreData, inline, labelWidth, light, gap = 12 }: IProps) {
  const theme = useTheme()
  const [showMore, setShowMore] = useState(false)

  function mapData(data: IComponentProps<typeof LabelInfo>[]) {
    return data.map((datum, i) => (
      <LabelInfo key={i} inline={inline} light={light} labelWidth={labelWidth} {...datum} />
    ))
  }

  return (
    <Grid gap={gap}>
      {mapData(data)}
      {showMore && moreData && mapData(moreData)}
      {moreData && (
        <div
          css={css`
            margin: 0 -8px -8px;
          `}
        >
          <Button
            onClick={() => setShowMore(!showMore)}
            buttonStyle="text"
            extendTheme={{ padding: 8, color: theme.themeColor("primary"), fontSize: 12 }}
          >
            {showMore ? "Show less" : "Show more"}
          </Button>
        </div>
      )}
    </Grid>
  )
}
